        const TRIP_BAND_COLOUR = { low: 'var(--green)', moderate: 'var(--amber)', high: 'var(--amber)', critical: 'var(--red)' };

export { TRIP_BAND_COLOUR };
